<section class="downloads-panel">
  <header class="downloads-panel-header">
    <div class="d-flex align-items-center">
      <nmfta-icon name="file_download" class="file_download"></nmfta-icon>
      <h2 class="ps-3">{{ 'Generic_RecentFiles' | translate }}</h2>

    </div>
    <nmfta-button (buttonClick)="close()" iconName="close" color="error" [blackText]="true"/>
  </header>

  <div class="d-flex flex-column gap-3 py-5">
    @if (jobs().length === 0) {
      <p>No downloads found.</p>
    } @else {
      @for (job of jobs(); track $index) {

        <nmfta-data-panel [title]="job.fileType ?? ''"
                          [propertyName]="job.fileName ?? ''"
                          [description]="(job.timestamp | date: 'EEEE, MMM d \' at\' h:mm a') ?? '' "
                          actionType="button"
                          [icon]="getIcon(job)"
                          [actions]="getActions(job)"
                          [tags]="getTag(job)"/>

      }
    }
  </div>
</section>
